<!-- eslint-disable vue/no-v-model-argument -->
<template>
    <b-row v-if="devicesPerPage.length">
        <el-table :data="devicesPerPage" stripe style="width: 100%">
            <el-table-column prop="deviceType" label="Device Type"  />
            <el-table-column prop="id" label="Id"/>
            <el-table-column prop="side" label="Side"/>
            <el-table-column align="right">
      <template #default="scope">
        <el-button
          @click="handleDelete(scope.$index, scope.row)"
          >Delete</el-button
        >
      </template>
    </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :total="patientDevices.length" @current-change="changePage"
            v-model:current-page="currentPage" v-model:page-size="perPage"/>
    </b-row>
</template>
<script>

import { ref, watchEffect } from 'vue'
import removeDeviceFromUser from '../composables/removeDeviceFromUser'
import { useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'

export default {
  name: 'OwnedDevice',
  props: ['patientDevices'],
  setup (props) {
    const currentPage = ref(1)
    const perPage = 10
    const devicesPerPage = ref([])
    const { removeDevice, removing } = removeDeviceFromUser()
    const router = useRouter()
    watchEffect(() => {
      devicesPerPage.value = props.patientDevices.slice(0, perPage)
    })

    const changePage = () => {
      const start = (parseInt(currentPage.value) - 1) * perPage
      const end = start + perPage
      devicesPerPage.value = props.patientDevices.slice(start, end)
    }

    const handleDelete = async (index, row) => {
      ElMessageBox.confirm(`This will remove device '${row.id}'`, 'Remove Device', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await removeDevice(row.id)
        router.go()
      }).catch((e) => {
        console.log(e)
      })
    }

    return {
      currentPage,
      changePage,
      devicesPerPage,
      perPage,
      handleDelete,
      removing
    }
  }
}
</script>

<style scoped>
    .deviceImg {
        width: 50%;
    }
</style>
